import React from 'react';
import PropTypes from 'prop-types';
import mailcheck from 'mailcheck';
import SuggestionBubble from "./SuggestionBubble";
import { Container } from "./styles";


class MailCheck extends React.Component {
	// Absolutely shamelessly stolen from https://github.com/eligolding/react-mailcheck
	state = {
		suggestion: null,
		// let's cache zIndex so it doesn't stutter
		zIndex: -1,
	};

	componentDidMount() {
		this.checkEmail(this.props.email);
		this.zIndex = this.props.zIndex;
	}

	componentDidUpdate(prevProps) {
		if (this.props.email !== prevProps.email) {
			this.checkEmail(this.props.email);
		}
		if (this.props.zIndex !== this.state.zIndex) {
			this.setState({ zIndex: this.props.zIndex });
		}
	}

	checkEmail = (email) => {
		const {
			domainThreshold,
			secondLevelThreshold,
			topLevelThreshold,
			domains,
			topLevelDomains,
			secondLevelDomains,
			distanceFunction
		} = this.props;

		mailcheck.domainThreshold = domainThreshold || mailcheck.domainThreshold;
		mailcheck.secondLevelThreshold = secondLevelThreshold || mailcheck.secondLevelThreshold;
		mailcheck.topLevelThreshold = topLevelThreshold || mailcheck.topLevelThreshold;

		mailcheck.run({
			email,
			domains,
			topLevelDomains,
			secondLevelDomains,
			distanceFunction,
			suggested: (suggestion) => {
				this.setState({
					suggestion,
				});
			},
			empty: () => {
				if (this.state.suggestion) {
					this.setState({ suggestion: null });
				}
			},
		});
	};

	render() {
		const { children, shouldHide, fillSuggestedEmail } = this.props;
		const { suggestion } = this.state;
		if (shouldHide) {
			return children;
		}
		return (
			<Container>
				{children}
				<SuggestionBubble
					suggestedText={suggestion ? suggestion.full : ''}
					fillSuggestedEmail={fillSuggestedEmail}
					zIndex={this.state.zIndex}/>
			</Container>
		);
	}
}

MailCheck.propTypes = {
	email: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	zIndex: PropTypes.number,
	shouldHide: PropTypes.bool,
	domainThreshold: PropTypes.number,
	secondLevelThreshold: PropTypes.number,
	topLevelThreshold: PropTypes.number,
	domains: PropTypes.array,
	topLevelDomains: PropTypes.array,
	secondLevelDomains: PropTypes.array,
	distanceFunction: PropTypes.func,
	fillSuggestedEmail: PropTypes.func,
};

MailCheck.defaultProps = {
	shouldHide: false
};

export default MailCheck;
